<app-header></app-header>
<section class="inerpages-banner">
  <img src="{{ imgurl }}{{ bnrAr['picture'] }}" class="w-100" />
  <div class="fade-bg"></div>
  <div class="mask-content-v-center text-center">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="tbox-iner text-center animate zoomIn" data-anim-type="zoomIn">
            <div class="heading-iner">
              <h2 *ngIf="showLang == 'en'">{{ bnrAr["smallCaption"] }}</h2>
              <h2 *ngIf="showLang == 'ar'">{{ bnrAr["smallCaption_ar"] }}</h2>

              <hr />
              <p *ngIf="showLang == 'en'">{{ bnrAr["bigCaption"] }}</p>
              <p *ngIf="showLang == 'ar'">{{ bnrAr["bigCaption_ar"] }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="checkout-page py-5">
  <div class="container">
    <div class="row">
      <div class="your-cart col-md-4 order-md-2 mb-4">
        <ul class="list-group mb-3">
          <li class="list-group-item">
            <h4 class="d-flex justify-content-between align-items-center mt-2">
              <span class="text-muted">{{
                "checkout.your_cart" | translate
              }}</span>
              <span class="badge badge-secondary badge-pill">{{
                storedCart.length
              }}</span>
            </h4>
          </li>
          <li class="list-group-item d-flex justify-content-between lh-condensed" *ngFor="let cart of storedCart">
            <div>
              <h6 class="my-0" *ngIf="showLang == 'en'">{{ cart.pName }}</h6>
              <h6 class="my-0" *ngIf="showLang == 'ar'">{{ cart.pName_ar }}</h6>

              <h6 class="my-0 addi-info" *ngIf="cart.pComent && cart.pComent != ''">
                (Additional Instruction: {{ cart.pComent }})
              </h6>
            </div>
            <span class="text-muted">AED {{ cart.totalPrice }}</span>
          </li>

          <li class="list-group-item d-flex justify-content-between">
            <span class="total">{{ "cart.cart_total" | translate }}</span>
            <strong>AED {{ this.total }}</strong>
          </li>

          <li class="list-group-item d-flex justify-content-between">
            <span class="total">{{
              "checkout.cutlery_needed" | translate
            }}</span>
            <strong>{{ cutlery | uppercase }}</strong>
          </li>

          <li class="list-group-item d-flex justify-content-between">
            <span class="total">{{
              "checkout.delivery_charge" | translate
            }}</span>
            <strong>+ AED {{ this.shipChrage }}</strong>
          </li>

          <li class="list-group-item d-flex justify-content-between">
            <dt>
              <strong>{{ "checkout.total_amount" | translate }} :</strong>
            </dt>
            <dd class="text-right">
              <strong> AED {{ this.totalWithShiping }} </strong>
            </dd>
          </li>

          <li class="list-group-item d-flex justify-content-between bg-light" *ngIf="cpnCode != ''">
            <div class="text-success">
              <h6 class="my-0">{{ "checkout.promo_code" | translate }}</h6>
              <small>{{ cpnCode }}</small>
            </div>
            <span class="text-success">- AED {{ discountedAmount }}</span>
            <button class="btn remove-coupon comm-btn" (click)="removeCpn()">
              <i class="fas fa-trash-alt" aria-hidden="true"></i>
            </button>
          </li>

          <li class="list-group-item d-flex justify-content-between bg-light" *ngIf="usedPrice">
            <div class="text-success">
              <h6 class="my-0">
                {{ "checkout.reward_points" | translate }}
                <button class="btn btn-danger remove-coupon comm-btn" (click)="removeRewardPoints()">
                  <i class="fas fa-trash-alt" aria-hidden="true"></i>
                </button>
              </h6>
            </div>

            <span class="text-success">- AED {{ usedPrice }}</span>
          </li>

          <li class="list-group-item d-flex justify-content-between">
            <dt>
              <strong>{{ "checkout.net_payable" | translate }}</strong>
            </dt>
            <dd class="text-right">
              <strong>AED {{ this.netPayable }}</strong>
            </dd>
          </li>

          <li class="list-group-item d-flex justify-content-between">
            <dt>{{ "checkout.included_tax" | translate }} (5%)</dt>
            <dd class="text-right">AED {{ this.taxAmt }}</dd>
          </li>
        </ul>

        <ul class="list-group coupon-appli">
          <h4>
            <span class="text-muted">
              {{ "checkout.your_points" | translate }}
            </span>
          </h4>
          <p class="mt-3">
            {{ "checkout.avl_points" | translate }}: {{ rewardPoints }}
          </p>

          <button (click)="redeemReward()" [disabled]="isRedeem" class="btn Shopping-btn Cout-btn">
            {{ "checkout.redeem" | translate }}
            <span *ngIf="isRedeemLoading">
              <i class="fas fa-circle-notch fa-spin"></i>
            </span>
          </button>

          <div *ngIf="isrewardMsg">
            <p class="mt-3 text-danger">
              {{ "checkout.coupon_msg" | translate }}
            </p>
            <a class="btn remove-coupon comm-btn" (click)="removeCpn()">{{
              "checkout.remove_coupon" | translate
            }}</a>
          </div>
        </ul>
      </div>
      <div class="billing-details col-md-8 order-md-1">
        <h2 class="">{{ "checkout.checkout_details" | translate }}</h2>

        <div *ngIf="adrsData; else addAdrs">
          <div class="seladd">
            <h5>{{ "checkout.delivery_address" | translate }}</h5>
          </div>
          <div class="row">
            <div class="col-md-6 address mb-3">
              <h4>{{ adrsData["userName"] }}</h4>
              <p>{{ adrsData["apartment"] }}</p>
              <p>{{ adrsData["address_one"] }}</p>
              <p>{{ adrsData["address_two"] }}</p>
              <p>{{ adrsData["area"] }}</p>
              <p>{{ adrsData["city"] }}</p>
              <p>{{ adrsData["state"] }}</p>
              <!-- <p>{{ adrsData["country"] }}</p> -->

              <a class="btn mt-3 comm-btn" href="javascript:void(0)" data-toggle="modal" data-target="#myModal"
                *ngIf="isMultipleAdrs">Change Address</a>
            </div>
          </div>
        </div>

        <p *ngIf="outofZone" class="shop-closed">
          Sorry, This order cannot be delivered on this location.
          <!-- {{ "cart.donot_deliver" | translate }} -->
        </p>



        <input type="checkbox" id="pickup" class="mr-1" (change)="pickUPstore(pickup)" #pickup />
        <label class="schedeli" for="pickup"> Pick up from store </label>
        <br>

        <select *ngIf="pickUp==1" name="pickbranch" class="form-control" #pickbranch
          (change)="getBranchName(pickbranch.value)">
          <option>Select pick up branch </option>
          <option value="Tourist Club">Tourist Club</option>
          <option value="Cournish">Cournish</option>
        </select>
        <p *ngIf="branchMsg != '' && showLang == 'en'" class="text-danger valid-danger-text mt-3">
          {{ branchMsg }}
        </p>


        <ng-template #addAdrs>
          <a class="btn btn-lg btn-block comm-btn mb-3"
            routerLink="/my-account/add-address">{{ "checkout.add_address" | translate }}</a>
        </ng-template>

        <input type="checkbox" class="mr-1" id="delSch" [checked]="chkIsFeast"
          (change)="scheduleDelivery(showDevlivery)" #showDevlivery />
        <label class="schedeli" for="delSch">{{
          "checkout.shedule_delivery" | translate
        }}</label>
        <div *ngIf="showscheduleDelivery">
          <form class="form-inline">
            <div class="form-group mx-sm-6 mb-2">
              <input type="date" class="form-control date date-from" name="dl_date" (change)="getDate(date.value)"
                placeholder="Choose date" [value]="orderfeastDate" #date />
            </div>

            <div class="form-group mx-sm-6 mb-2">
              <select name="from_time" class="form-control date-from" (change)="getfromTime(fromtime.value)" #fromtime>
                <option value="">{{ "checkout.from_time" | translate }}</option>
                <option *ngFor="let timing of timings" [value]="timing" [selected]="orderfeastTime == timing">
                  {{ timing }}
                </option>
              </select>
            </div>
          </form>
          <p *ngIf="schMsg != '' && showLang == 'en'" class="text-danger valid-danger-text mt-3">
            {{ schMsg }}
          </p>
          <p *ngIf="schMsg != '' && showLang == 'ar'" class="text-danger valid-danger-text mt-3">
            {{ schMsg_ar }}
          </p>
        </div>

        <div>
          <h6>Delivery Instructions</h6>
          <input class="form-control" type="text" name="del_inst" #del_inst>
        </div>
        <div class="donotdeliver" *ngIf="!outofZone">
          <div class="billing-details mt-3" *ngIf="shopStatus == 0 ">
            <h2 class="mb-3">{{ "checkout.make_payment" | translate }}</h2>

            <ul class="nav nav-tabs" id="myTab" role="tablist">
              <li class="nav-item">
                <a class="nav-link active" id="pills-home-tab" data-toggle="pill" href="#credit-card" role="tab"
                  (click)="getPaymentMethod('Card')" aria-controls="pills-home"
                  aria-selected="true">{{ "checkout.card" | translate }}</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" id="pills-profile-tab" data-toggle="pill" href="#cashon-delivery"
                  (click)="getPaymentMethod('COD')" role="tab" aria-controls="pills-profile"
                  aria-selected="false">{{ "checkout.cashon_delivery" | translate }}</a>
              </li>
            </ul>
            <div class="tab-content" id="myTabContent">
              <div class="tab-pane fade show active" id="credit-card" role="tabpanel" aria-labelledby="pills-home-tab">
                <div id="addNewcard" [ngClass]="{'AddnewCard' : showAddnewCard}">
                  <p class="addnccls" (click)="addnewCard()">Add New Card</p>
                </div>
                <div class="card-form" [ngClass]="{'showCardForm' : showCardFrm}">
                <form id="payment-form" method="POST" action="{{ API_URL }}make-payment" #f="ngForm">
                  <div class="card-frame">
                    <!-- form will be added here -->
                  </div>
                  <!-- add submit button -->

                  <input type="hidden" value="{{ cardAmount }}" name="amount" />
                  <input type="hidden" value= "{{ lastOrderId }}" name="order_id" />
                  <input type="hidden" value= "{{ cuserName }}" name="uname" />
                  <input type="hidden" value="{{ cuserEmail }}" name="uemail" />
                  

                  <button class="btn btn-lg Shopping-btn btn-block d-none" id="pay-button" disabled
                    (click)="onPaymentClick(del_inst.value, null)" #paybtn>
                    PAY AED {{ this.netPayable }}
                  </button>

                  <br>

                  <input id="save_for_futre" type="checkbox" checked name="save_card_futre" value="1">
                  <label for="save_for_futre" class="ml-1"> Save card for future payments</label>

                </form>

                <button class="btn btn-lg Shopping-btn pay-button" id="pay_button_custom" disabled
                  (click)="onPaymentClick(del_inst.value, null)">
                  PAY AED {{ this.netPayable }}
                  <span *ngIf="isLoading">
                    <i class="fas fa-circle-notch fa-spin"></i>
                  </span>
                </button>
              </div>

              <!-- saved card code starts here -->

                <div class="saved list" *ngIf="savedCardData.instruments">
                  <div class="sub--title">Saved Cards</div><br>
                  <form #savedCardfrm (ngSubmit)="onSubmit(savedCardfrm, $event)" method="POST"
                    action="{{ API_URL }}make-payment">
                    <div class="cards">
                    
                      <input type="hidden" name="svedCard" value="1">
                      <input type="hidden" name="amount" value={{this.cardAmount}}>
                      <input type="hidden" #order_id id="order_id" value= "{{ lastOrderId }}" name="order_id" />

                    <div *ngFor="let item of savedCardData.instruments; index as i;" class="saved-card">

                      <input type="radio" (change)="cardSelect()" id="scard_{{i}}" name="scard" value={{item.id}}>
                      <label for="scard_{{i}}">
                        <span class="img">
                          
                          <svg class="icon" *ngIf="item.scheme === 'VISA'"><use xlink:href="/assets/img/svgdefs-2.svg#visa-dark"></use></svg>
                          <svg class="icon" *ngIf="item.scheme === 'MASTERCARD'"><use xlink:href="/assets/img/svgdefs-2.svg#mc-dark"></use></svg>
                          <svg class="icon" *ngIf="item.scheme === 'DISCOVER'"><use xlink:href="/assets/img/svgdefs-2.svg#discover-dark"></use></svg>
                          <svg class="icon" *ngIf="item.scheme === 'AMERICAN EXPRESS'"><use xlink:href="/assets/img/svgdefs-2.svg#amex-dark"></use></svg>
                          <svg class="icon" *ngIf="item.scheme === 'JCB'"><use xlink:href="/assets/img/svgdefs-2.svg#jcb-dark"></use></svg>
                        </span>
                        <span class="content">
                          <b>{{item.scheme}} Ending in {{item.last4}}</b>
                          <br> Expire on {{item.expiry_month}} / {{item.expiry_year}}
                        </span>
                       
                      </label>
                      <span (click)="deleteSaveCard(item.id)" data-toggle="tooltip" data-placement="left" title="Remove Card" class="delete-btn"><i class="fa fa-trash"
                        aria-hidden="true"></i></span>
                      
                    </div>
                    </div>
                    
                    <input type="submit" class="d-none"  #paybySavedCardbtn>  
                    
                  </form>
                  <div class="right-btn" id="svpbtn" #svpbtn [ngClass]="{'hidePayBtn' : showCls}">
                    <button (click)="onPaymentClick(del_inst.value,'saved_card')" class="btn btn-lg Shopping-btn pay-button">PAY AED {{ this.netPayable }}
                      <span *ngIf="isLoading">
                        <i class="fas fa-circle-notch fa-spin"></i>
                      </span>
                    </button>
                  </div>
                  
                </div>
                <!-- saved card code ends here -->

              </div>
              <div class="tab-pane fade" id="cashon-delivery" role="tabpanel" aria-labelledby="pills-profile-tab">
                <button class="btn-lg Shopping-btn btn-block" [disabled]="isCodClicked"
                  (click)="onPaymentClick(del_inst.value, null)">
                  {{ "checkout.confirm_order" | translate }}
                  <span *ngIf="isLoading">
                    <i class="fas fa-circle-notch fa-spin"></i>
                  </span>
                </button>
              </div>

              <p class="text-danger mb-0 valid-danger-text mt-3" *ngIf="this.dlvrMsg != '' && showLang == 'en'">
                {{ this.dlvrMsg }}
              </p>
              <p class="text-danger mb-0 valid-danger-text mt-3" *ngIf="this.dlvrMsg != '' && showLang == 'ar'">
                {{ this.dlvrMsg }}
              </p>
              <a *ngIf="showShopping" class="continue-shopp" [routerLink]="['/order-online']">{{
              "cart.continue_shopping" | translate
            }}</a>
            </div>

          </div>
        </div>

        <p *ngIf="shopStatus == 1" class="shop-closed">
          {{ "cart.shop_closed" | translate }}
        </p>
      </div>
    </div>
  </div>

  <!-- Modal -->
  <div class="modal fade" id="myModal" role="dialog">
    <div class="modal-dialog modal-lg">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title main-heading">
            {{ "checkout.select_address" | translate }}
          </h5>
          <button type="button" class="close" data-dismiss="modal">
            &times;
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-6 address mb-3" *ngFor="let adrs of allAdrs">
              <h4>{{ adrs.userName }}</h4>
              <p>{{ adrs.apartment }}</p>
              <!-- <p>{{ adrs.address_one }}</p> -->
              <p>{{ adrs.address_two }}</p>
              <p>{{ adrs.area }}</p>
              <p>{{ adrs.city }}</p>
              <p>{{ adrs.state }}</p>
              <!-- <p>{{ adrs.country }}</p> -->

              <div class="seladd">
                <input type="radio" id="adr{{ adrs.id }}" class="mr-1" name="adrs_id_2" (change)="getAddrsId(adrsvl2)"
                  [attr.lat]="adrs.lat" [attr.long]="adrs.long" [attr.uname]="adrs.userName"
                  [attr.apartment]="adrs.apaetment" [attr.adr-1]="adrs.address_one" [attr.adr-2]="adrs.address_two"
                  [attr.area]="adrs.area" [attr.city]="adrs.city" [attr.state]="adrs.state"
                  [attr.country]="adrs.country" value="{{ adrs.id }}" #adrsvl2 />

                <label for="adr{{ adrs.id }}">
                  {{ "checkout.deliver_thisaddress" | translate }}</label><br />
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" #closebutton class="btn close-btn btn-default" data-dismiss="modal">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</section>
